import { ADAS2_CANCEL_CODE_IDS } from './CancelCodeConstants';

// ADAS2対象IDならADAS2、それ以外のIDならADAS1として判定する
export const isAdas2CancelCode = (cancelCodeId) => {
  return ADAS2_CANCEL_CODE_IDS.includes(String(cancelCodeId));
};